const getFieldError = (field, value) => {
  switch (field) {
    case "comment":
      return value && value.trim() ? null : "* Required";
    case "voidReason":
      return value ? null : "* Required";
    default:
      return null;
  }
};

const getErrorInfo = (errorInfo, voidPickupData) => {
  const newErrorInfo = {};
  Object.keys(errorInfo).forEach((fieldName) => {
    newErrorInfo[fieldName] = getFieldError(
      fieldName,
      voidPickupData[fieldName]
    );
  });
  return newErrorInfo;
};

const getDefaultVoidPickData = () => ({
  voidReason: null,
  comment: null,
  errorInfo: {
    comment: null,
    voidReason: null
  },
});

export { getFieldError, getErrorInfo, getDefaultVoidPickData };
